// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useState, useImperativeHandle, useCallback} from 'react';
import {createRoot} from 'react-dom/client';
import {ThemeProvider} from 'uikit';
import etask from '/util/etask.js';
import {Text} from '@pub/comp/text';
import {Popup, CLOSE_ANIMATION_DURATION} from '@pub/comp/popup';

const dummy_elem = document.createElement('div');
dummy_elem.classList.add('sdk-confirm');
document.body.appendChild(dummy_elem);

function Confirm({show, et, title, text, confirm_label, cancel_label}){
    const ok_label = confirm_label || 'OK';
    const not_ok_label = cancel_label || 'Cancel';
    const popup_title = title || 'Confirm';
    const confirm = useCallback(()=>et?.return?.(true), [et]);
    const close = useCallback(()=>et?.return(false), [et]);
    let content = null;
    if (text)
        content = text;
    else
        content = <Text.s>Are you sure?</Text.s>;
    return <Popup title={popup_title} show={show} on_close={close}
      on_ok={confirm} submit_label={ok_label} cancel_label={not_ok_label}
      reverse_btn_colors>
      <div className="sc_content">{content}</div>
    </Popup>;
}

const Confirm_wrap = React.forwardRef(function Wrap(_, ref){
    const [show, set_show] = useState(false);
    const [et, set_et] = useState(null);
    const [params, set_params] = useState({});
    useImperativeHandle(ref, ()=>({
        set_show,
        set_et,
        set_params,
    }), []);
    return <Confirm show={show} et={et} title={params.title} text={params.text}
      confirm_label={params.confirm_label}
      cancel_label={params.cancel_label}/>;
});

let wrap_ref = null;
const root = createRoot(dummy_elem);

root.render(<ThemeProvider>
  <Confirm_wrap ref={ref=>wrap_ref = ref}/>
</ThemeProvider>);

export const confirm = ({title, text, confirm_label, cancel_label})=>
etask(function(){
    this.finally(()=>{
        wrap_ref.set_et(null);
        wrap_ref.set_show(false);
        setTimeout(()=>wrap_ref.set_params({}), CLOSE_ANIMATION_DURATION+10);
    });
    wrap_ref.set_params({title, text, confirm_label, cancel_label});
    wrap_ref.set_et(this);
    wrap_ref.set_show(true);
    return this.wait();
});
